module.exports = __webpack_public_path__ + "static/img/8.a01c4c3.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/1/eng/8.png
// module id = wVCf
// module chunks = 0